/**
 * IP18 What's in the Box — tab hard-cut between kit panels.
 */
(function () {
  'use strict';

  class Ip18BoxTabs extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this._tabs = Array.prototype.slice.call(this.querySelectorAll('[data-ip18-box-tab]'));
      this._panels = Array.prototype.slice.call(this.querySelectorAll('[data-ip18-box-panel]'));
      this._onClick = this._onClick.bind(this);
      this._onKey = this._onKey.bind(this);
      this.addEventListener('click', this._onClick);
      this.addEventListener('keydown', this._onKey);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('keydown', this._onKey);
    }

    _onClick(event) {
      var tab = event.target.closest('[data-ip18-box-tab]');
      if (!tab || !this.contains(tab)) return;
      var index = Number(tab.getAttribute('data-index'));
      if (isNaN(index)) return;
      this._sync(index);
    }

    _onKey(event) {
      if (!event.target.closest('[data-ip18-box-tab]')) return;
      var current = this._tabs.findIndex(function (el) {
        return el.getAttribute('aria-selected') === 'true';
      });
      if (current < 0) current = 0;
      var next = current;
      if (event.key === 'ArrowRight') next = Math.min(this._tabs.length - 1, current + 1);
      else if (event.key === 'ArrowLeft') next = Math.max(0, current - 1);
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = this._tabs.length - 1;
      else return;
      event.preventDefault();
      this._sync(next);
      this._tabs[next].focus();
    }

    _sync(index) {
      this._tabs.forEach(function (el) {
        var on = Number(el.getAttribute('data-index')) === index;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-selected', on ? 'true' : 'false');
        el.tabIndex = on ? 0 : -1;
        if (on && el.scrollIntoView) {
          el.scrollIntoView({ inline: 'center', block: 'nearest' });
        }
      });
      this._panels.forEach(function (el) {
        var on = Number(el.getAttribute('data-index')) === index;
        el.hidden = !on;
      });
    }
  }

  if (!customElements.get('ip18-box-tabs')) {
    customElements.define('ip18-box-tabs', Ip18BoxTabs);
  }
})();
